module.exports = __webpack_public_path__ + "static/media/Roboto-Black.ec4c9962.ttf";